import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(5, 1, 2)};
`;
